<template>
    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/herramientas-inteligencia-artificial-humanitas.webp" alt="Herramientas de inteligencia artificial aplicadas en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Política y uso de herramientas IA en</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="isVirtual" class="block text-hgreen text-left font-serif mb-3 text-[42px]">Universidad Humanitas</span>
                            <span v-else class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas</span>
                        </h2>
                        <div class="text-justify">
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">En Humanitas entendemos que el mundo está cambiando a gran velocidad. La Inteligencia Artificial ya forma parte del día a día de los estudiantes, y en lugar de rechazarla, enseñamos a aprovecharla con inteligencia, ética y sentido crítico.</p>
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">Los alumnos no solo aprenderán a usar herramientas como ChatGPT, editores inteligentes o plataformas personalizadas. Desarrollarán capacidad de pensamiento crítico y analítico con el objetivo de debatir y defender las ideas, combinando tecnología avanzada con el desarrollo humano.
                            </p>
                            <p class="mb-4 lg:hyphens-manual hyphens-auto">Nuestro modelo académico integra la IA como una aliada del aprendizaje, pero nunca como un sustituto del pensamiento. Formamos para enfrentar el futuro con criterio, creatividad y preparación real.
                            </p>
                            <p class=" font-semibold text-center">Estudia en Humanitas, donde la tecnología potencia tu mente, no la reemplaza.</p>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
    props: {
        isVirtual: {
        type: Boolean,
        default: false
        }
    }
}
</script>

<style>

</style>